// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCsuKqujf8w384l9PA9GtlPty3FBfHsI3A",
  authDomain: "infobligations.firebaseapp.com",
  projectId: "infobligations",
  storageBucket: "infobligations.firebasestorage.app",
  messagingSenderId: "867538932354",
  appId: "1:867538932354:web:3a75658b1417aa5b609a9b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);